var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"404","sub-title":"Strona nie istnieje!","title":"404"}})
}
var staticRenderFns = []

export { render, staticRenderFns }